import { Org, OrgFeatureKey } from 'domain-types';

import { PageDescriptor } from './page-descriptor';

export const defaultOrgFeatures: Record<OrgFeatureKey, boolean> = {
  apps: true,
  leave: true,
  expenses: true,
  mcp: false
};

const pageFeatureRules: Partial<Record<string, OrgFeatureKey | OrgFeatureKey[]>> =
  {
    actions: ['leave', 'expenses'],
    leave: 'leave',
    expenses: 'expenses',
    expenseClaimDetail: 'expenses',
    leaveBalances: 'leave',
    leaveAnalytics: 'leave'
  };

type OrgFeatureSource = Pick<Org, 'features'> | null | undefined;

export const getOrgFeatures = (org?: OrgFeatureSource) => ({
  ...defaultOrgFeatures,
  ...(org?.features ?? {})
});

export const isOrgFeatureEnabled = (
  org: OrgFeatureSource,
  feature: OrgFeatureKey
) => getOrgFeatures(org)[feature];

export const isAnyOrgFeatureEnabled = (
  org: OrgFeatureSource,
  features: OrgFeatureKey[]
) => features.some(feature => isOrgFeatureEnabled(org, feature));

export const isPageEnabledForOrg = (
  pageKey: string,
  org: OrgFeatureSource
) => {
  const rule = pageFeatureRules[pageKey];

  if (!rule) {
    return true;
  }

  return Array.isArray(rule)
    ? isAnyOrgFeatureEnabled(org, rule)
    : isOrgFeatureEnabled(org, rule);
};

export const filterOrgEnabledPageEntries = <T extends PageDescriptor>(
  pageEntries: Array<[string, T]>,
  org: OrgFeatureSource
) => pageEntries.filter(([pageKey]) => isPageEnabledForOrg(pageKey, org));
